
import Config from './Config'
import Http from './Http';
import { processDates } from './ItemsStore';

function getExtension(filename) {
    return filename.substring(filename.lastIndexOf('.') + 1, filename.length) || filename
}

function updateFileAttachments(files) {
    if (files && files.length > 0) {
        files.forEach(f => {
            f.fileName = f.formType + "." + getExtension(f.fileName)
        })
    }
    return files;
}

export function processStorageFiles(data) {
    if (data) {
        function process(datum) {
            if (datum && datum.hasOwnProperty('fileName') && datum.fileName && datum.formType) {
                datum.fileName = datum.formType + "." + getExtension(datum.fileName);
                /*const oldFilename = datum.fileName;
                const index = oldFilename.indexOf('__');
                if (index > 0) {
                    const fileNameWithoutUuid = oldFilename.slice(index + 2);
                    datum.fileName = fileNameWithoutUuid;
                }*/
            }
        }
        function updateVersionNumber(data) {

            data.sort((a,b) => (a.createdTime - b.createdTime));

            var versionFormType = {}

            function getVersionOrDefault(key, defaultValue) {
                if (versionFormType.hasOwnProperty(key)) {
                    return versionFormType[key]
                }
                return defaultValue;
            }

            data.forEach(datum => {
                var version = getVersionOrDefault(datum.formType, 1);
                datum.version = version;
                versionFormType[datum.formType] = version + 1;
            })
        }
        if (Array.isArray(data)) {
            data.forEach((datum) => {
                process(datum);
            });
            updateVersionNumber(data);
        } else {
            process(data);
        }
    }
    return data;
}


class FileStorage {

    constructor() {
    }

    download(fileId) {
        const url = `/storage/file/${fileId}`;
        var anchor = document.createElement('a');
        anchor.href = url;
        anchor.target = '_blank';
        anchor.download = '';
        anchor.click();
    }

    downloadAllAttachments(objectId) {
        const url = `/storage/download-all-files-for-object/${objectId}`;
        console.log(url)
        var anchor = document.createElement('a');
        anchor.href = url;
        anchor.target = '_blank';
        anchor.download = '';
        anchor.click();
    }

    downloadAllAttachmentsForUser(userId) {
        const url = `/storage/download-all-files-for-user/${userId}`;
        console.log(url)
        var anchor = document.createElement('a');
        anchor.href = url;
        anchor.target = '_blank';
        anchor.download = '';
        anchor.click();
    }

    async getFilesForObject(objectId, contentType) {
        const data = (await Http.get(`/storage/files-for-object/${objectId}`)).data;
        return processStorageFiles(processDates(data));
    }

    async getDownloadAsBlob(fileId, contentType) {
        const data = (await Http.get(`/storage/sas/${fileId}`)).data;
        const blob = new Blob([data], {
            type: contentType
        });
        return URL.createObjectURL(blob);
    }

    getDownloadUrl(fileId) {
        return `/storage/file/${fileId}`;
    }

    async getSASUrl(fileId) {
        const sasToken = (await Http.get(`/storage/sas/${fileId}`)).data;
        return Config.BASE_URL + "/storage/sas-file/" + sasToken;
    }

    async upload(file, newFilename, formType, attachToObjectId = null, attachedToObjectType = null, abortSignal = null) {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("newFilename", newFilename || "");

        if (formType) {
            formData.append("formType", formType);
        }
        if (attachToObjectId) {
            formData.append("attachToObjectId", attachToObjectId);
        }
        if (attachedToObjectType) {
            formData.append("attachedToObjectType", attachedToObjectType);
        }

        const uploadedFile = (await Http.post('/storage/upload', formData, {
            signal: abortSignal,
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })).data;
        return uploadedFile;
    }

    chat(chatHistory, newMessage) {

        chatHistory = chatHistory || []
        chatHistory.push(({
            role: 'user',
            content: newMessage
        }))
        return Http.post(`/storage/chat`, chatHistory);
    }

}

const singletonInstance = new FileStorage();
export { singletonInstance as FileStorage };